import { api } from '@/lib/api';

export interface AdminLoginRequest {
  email: string;
  password: string;
}

export interface AdminRegisterRequest {
  appName: string;
  domain: string;
  adminDomain: string;
  firstName: string;
  lastName: string;
  email: string;
  password: string;
}

export interface AdminUser {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  avatar?: string;
  appId: string;
  status: string;
  createdAt: string;
  updatedAt: string;
}

export interface AdminLoginResponse {
  token: string;
  refreshToken?: string;
  expiresAt: Date;
  user: AdminUser;
  appName: string;
}

export class AdminAuthService {
  static async register(data: AdminRegisterRequest): Promise<AdminLoginResponse> {
    const response = await api.post('/auth/register', data);
    return response.data.data;
  }

  static async login(credentials: AdminLoginRequest): Promise<AdminLoginResponse> {
    const response = await api.post('/auth/login', credentials);
    return response.data.data;
  }

  static async refreshToken(refreshToken: string, signal?: AbortSignal): Promise<AdminLoginResponse> {
    const response = await api.post('/auth/refresh-token', { refreshToken }, { signal });
    return response.data.data;
  }

  static async getCurrentUser(signal?: AbortSignal): Promise<AdminUser> {
    const response = await api.get('/auth/me', { signal });
    return response.data.data;
  }

  static logout(): void {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_refresh_token');
  }
}
